import { getSettings } from '@hotjar/settings';
import { parse } from '@hotjar/webapp/domains/revenue/plan/feature-group';

import type { Limits } from '@hotjar/webapp/domains/common/settings';
import type { FeatureGroup } from '@hotjar/webapp/domains/revenue/plan/types';

/**
 * Get the limits of a specific feature filtered by the featureGroup name
 */
export const getLimitsByFeatureGroup = (
  featureName: keyof Limits,
  featureGroup: FeatureGroup,
): number | undefined => {
  const settings = getSettings();

  if (!settings) {
    throw new Error('Settings not loaded yet.');
  }

  if (!featureName) {
    throw new Error('Missing feature name');
  }

  if (!featureGroup) {
    throw new Error('Missing feature group');
  }

  if (!parse(featureGroup)) {
    throw new Error(`Wrong featureGroup: ${featureGroup}`);
  }

  return settings.plans[featureGroup]?.limits[featureName];
};
